/**
 * @file コンポーネント：検索絞り込みセクション DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import { StyledSection, StyledSectionHeadline } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledSection>
            <StyledSectionHeadline>{props.headline}</StyledSectionHeadline>
            {props.contents}
        </StyledSection>
    );
};
